<template>
  <div class="notice_wrapper">
    <div class="notice_cont_outer">
      <div class="notice_title">
        <div class="m_outer">
          <div class="m_title">惠企政策</div>
          <div class="m_tip">
            目前共有惠企政策<br/>
            {{all}}条
          </div>
        </div>
      </div>

      <div class="notice_list_outer">
        <div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow.png'"/><span>惠企政策</span></div>

        <div class="policy_tab">
          <div class="filter">

            <h4><span>政策类型：</span><span class="s"></span></h4>
            <div class="item_outer">
				  			<span v-for="item of policyList" :class="{'selected':selectPolicy===item.num}"
                      @click="selectItem2(item)">
				  				<b>{{ item.name }}</b>
				  				<i class="cloudicon ci_unvalid" v-show="selectPolicy===item.num&&selectPolicy!=-1"></i>
				  			</span>
            </div>
            <h4><span>主管机关：</span><span class="s"></span></h4>
            <div class="item_outer">
				  			<span v-for="item of deptList" :class="{'selected':selectDept===item.num}"
                      @click="selectItem(item)">
				  				<b>{{ item.name }}</b>
				  				<i class="cloudicon ci_unvalid" v-show="selectDept===item.num&&selectDept!=-1"></i>
				  			</span>
            </div>
            <h4><span>政策层级：</span><span class="s"></span></h4>
            <div class="item_outer">
				  			<span v-for="(item) of levelList" :class="{'selected':selectLevel===item.num}"
                      @click="selectItem3(item)">
				  				<b>{{ item.name }}</b>
				  				<i class="cloudicon ci_unvalid" v-show="selectLevel===item.num&&selectLevel!=-1"></i>
				  			</span>
            </div>
          </div>
        </div>
        <div class="tab_content hqzc">
          <el-table :data="tablelist" stripe @cell-click="toDetail" style="width: 100%">
            <el-table-column prop="post_title" label="政策名称" width="560"></el-table-column>
            <el-table-column prop="policy" label="政策类型" width="150"></el-table-column>
            <el-table-column prop="dept" label="主管机关" width="150"></el-table-column>
            <el-table-column prop="level" label="政策层级" width="150"></el-table-column>
            <el-table-column prop="published_time" label="发布时间" width="150" ></el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :current-page="currentPage"
            :page-size="pagesize"
            :total="total"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getAll();
    this.getPolicyList();
  },
  name: 'policy',
  data() {
    return {
      all:0,
      selectLevel: -1,
      selectDept: -1,
      selectPolicy: -1,
      policyList: [
        {num: -1, name: "全部"},
        {num: 1, name: "创业引导"},
        {num: 2, name: "研发转化"},
        {num: 3, name: "企业创新"},
        {num: 4, name: "先进制造业发展"},
        {num: 5, name: "现代服务业发展"},
        {num: 6, name: "节能环保"},
        {num: 7, name: "知识产权和品牌建设"},
        {num: 8, name: "投融资扶持"},
        {num: 9, name: "其他产业"}
      ],
      deptList: [
        {num: -1, name: "全部"},
        {num: 1, name: "发改委"},
        {num: 2, name: "经委"},
        {num: 3, name: "科委"},
        {num: 4, name: "旅游局"},
        {num: 5, name: "文广局"},
        {num: 6, name: "人社局"},
        {num: 7, name: "市监局"},
        {num: 8, name: "金融办"},
        {num: 11, name: "企业服务部"},
        {num: 12, name: "党群人事部"},
        {num: 13, name: "综合保税区管理部"},
        {num: 9, name: "其他"}
      ],
      levelList: [
        {num: -1, name: "全部"},
        {num: 4, name: "国家级"},//4
        {num: 3, name: "市级"},
        {num: 2, name: "奉贤区级"},//2
        {num: 1, name: "工业综合开发区"}//1
      ],
      currentPage: 1,
      pagesize: 10,
      tablelist: [],
      total: 0
    }
  },
  methods: {
  	tohome() {
      this.$router.push({name: 'homepage'})
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getPolicyList();
    },
    selectItem(item) {
      if(this.selectDept!=item.num){this.selectDept=item.num;}
      else{this.selectDept=-1;}
      this.getPolicyList();
    },
    selectItem2(item) {
      if(this.selectPolicy!=item.num){this.selectPolicy=item.num;}
      else{this.selectPolicy=-1;}
      this.getPolicyList();
    },
    selectItem3(item) {
      if(this.selectLevel!=item.num){this.selectLevel=item.num;}
      else{this.selectLevel=-1;}
      this.getPolicyList();
    },
    toDetail(row, column, event, cell) {
      this.$router.push({name: 'polidetail', query: {id: row.id}})
    },
    async getPolicyList() {
      let param='';
      if(this.selectLevel!=-1) param+='&level='+this.selectLevel;
      if(this.selectDept!=-1) param+='&dept='+this.selectDept;
      if(this.selectPolicy!=-1) param+='&policy='+this.selectPolicy;
      let res = await this.$ajax.get(this.bUrl + 'api/portal/lists/policy?page=' + this.currentPage+param+"&pagesize=10");
      this.tablelist = res.data.data.list;
      this.total = res.data.data.total;
    },
    async getAll(){
      let res = await this.$ajax.get(this.bUrl + 'api/portal/lists/policy?page=' + this.currentPage+"&pagesize=10");
      this.all = res.data.data.total;
    }
  }
}
</script>

<style scoped>
.notice_cont_outer {
  width: 1180px;
  margin: 0 auto;
  background: #fff url('/gyzhqyimgs/poli_bg.png') no-repeat -25px -150px;
}

.notice_title {
  height: 368px;
  display: flex;
  align-items: flex-end;
  position: relative;
}

.m_outer {
  padding: 20px;
}

.m_title {
  color: #143367;
  font-size: 28px;
  margin-bottom: 16px;
}

.m_tip {
  width: 160px;
  color: #2574AD;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.notice_list_outer {
  background: #fff;
  min-height: 500px;
}


.filter {
  width: 100%;
  height: 100%;
  background: #fff;
  padding:0 25px 25px 25px;
}

.filter .item_outer {
  width: 100%;
  display: flex;
  /*justify-content: space-between;*/
  flex-wrap: nowrap;
  text-align: center;
  margin-bottom: 24px;
}

.filter h4 {
  font-size: 14px;
  font-weight: normal;
  line-height: 42px;
  color: #2574AD;
}

.filter .s {
  float: right;
  color: #36A0FF;
}

.filter .item_outer span {
  /*width: 31%;*/
  padding: 2px 8px 3px 8px;
  box-sizing: border-box;
  border: 2px solid transparent;
  background: #fff;
  border-radius: 3px;
  /*margin-bottom: 20px;*/
  display: flex;
  align-items: center;
  margin: 0 7px;
  color: #36A0FF;
  border: 1px solid #36A0FF;
  cursor: pointer;
  /*justify-content: center;*/
}

.filter .item_outer span.selected {
  background: #36A0FF;
  color: #fff;
  justify-content: space-between;
}

.filter .item_outer .cloudicon {
  margin-top: 2px;
}

.filter .item_outer b {
  font-weight: normal;
  /*text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;*/
}

.filter .item_outer span.selected b {
  /*width: 70%;*/
}

.tab_content {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/PreferentPolicy/policy.vue